import {
    get,
    $,
    $$,
    hide,
    toggle,
    postDataText,
    postData,
    initForm,
    remove,
    getFileNameFromResponse,
    getData,
    postDataJson,
    downloadFileFromBlob,
    centerActiveTab,
    postFormData, show, isHidden, gtmEvent, sleep
} from "@/Utils";
import { initCarousels } from "@/sharedComponents/Carousel/Carousel";
import { initDatePickers } from "@/Startup";
import { addedToCart, initParcelTerminals } from "@/CartModule";
import { initComparisons } from "@/ProductModule";
import { initContactInfoFields } from "@/AccountModule";
import {
    EcommerceData,
    EuronicsResponse,
    GtmAddToCartOptions,
    Item,
    ReviewProductForm,
    SendCreditLimitOffersResponse,
    VoidFunction
} from "@/interfaces"
import { fillPanelAndInitForm } from "@/sharedComponents/Header/CustomerService";
import {CustomerSupportSubType, GtmEventType, EditCartFrom} from "@/enums"
import { initStoreAndPostPackageSelections } from "@/StoreAndPostPackageSelection";
import { openPanel } from "@/sharedComponents/Panel";
import {validateForm} from "@/Validation";

function sendGaViewItemEventForWarranty(expandableBody: Element) {
    const warrantyButtons = expandableBody.querySelector('button.warranty') as HTMLElement
    if (warrantyButtons) {
        const ecommerceData = (warrantyButtons.dataset as unknown) as EcommerceData;
        const categories = ecommerceData.productCategoryTree.split("/")
        gtmEvent(GtmEventType.ViewItem, null, null, null, null, {
            eventName: GtmEventType.ViewItem,
            value: ecommerceData.productPrice,
            itemsGa4: [{
                itemName: ecommerceData.productName,
                itemId: ecommerceData.productCode,
                price: ecommerceData.productPrice,
                itemBrand: "",
                itemCategory: categories[0],
                itemCategory2: categories[1],
                itemCategory3: categories[2],
                itemListId: EditCartFrom.HistoryWarranty,
                itemListName: EditCartFrom[EditCartFrom.HistoryWarranty],
                quantity: 1,
                productId: Number(ecommerceData.productId),
                currency: 'EUR'
            } as Item]
        } as GtmAddToCartOptions)
    }
}

function initOpenExpandableClick() {
    $$(".expandable-header").forEach(x => {
        (x as Element).addEventListener("click",
            function () {
                const closestExpandable = this as Element;
                const button = closestExpandable.querySelector("button.expandable-header__open-button");
                const expandableBody = closestExpandable.parentNode.querySelector(".expandable-body");
                const expandableItems = closestExpandable.querySelector(".expandable-header__items");
                expandableBody.classList.toggle("expandable-body--open");
                sendGaViewItemEventForWarranty(expandableBody);
                toggle(expandableItems as HTMLElement);
                button.classList.toggle("open-icon");
            });
    });
}

function initProductAccessoriesClick() {

    $$(".product-accessories-button").forEach(x => {
        (x as Element).addEventListener("click", function () {
            const button = this as Element;
            button.classList.toggle("open-icon");
            const closestProduct = button.closest(".history-product");
            const productAccessories = closestProduct.querySelector(".history-product__accessories");
            productAccessories.classList.toggle("history-product__accessories--open");
        });
    });

}

function initClearFilterClick() {
    $$(".clear-filter-button").forEach(x => {
        (x as Element).addEventListener("click", () => {
            filterHistoryRowsClearDates();
        });
    });

}

function initOpenSavedLocationClick() {
    $$(".saved-shipping-location__header").forEach(x => {
        (x as Element).addEventListener("click", function () {
            const button = this as Element;
            const closestExpandable = button.closest('.saved-shipping-location');
            const expandableBody = closestExpandable.querySelector("saved-shipping-location__body");
            expandableBody.classList.toggle("saved-shipping-location__body--open");
        });
    });
}

function initRemoveFromFavorites() {
    $$(".my-saved-products__content [data-rem-fav-id]").forEach(x => {
        (x as Element).addEventListener("click", () => {
            const productId = parseInt((x as HTMLElement).getAttribute("data-rem-fav-id"));
            const callback = (resp: string) => {
                get("_SavedProducts").innerHTML = resp;
                initRemoveFromFavorites();
            }
            postDataText(window.config.removeFromFavoritesUrl, productId, callback);
        });
    });
}

function initSendEmailOffersChanged() {
    get("SendEmailOffers")?.addEventListener("change",
        (e) => {
            const sendEmailOffers = (e.target as HTMLInputElement).checked;
            postDataText(window.config.sendEmailOffersChangedUrl, sendEmailOffers);
        });
}

function initSendSmsOffersChanged() {
    get("SendSmsOffers")?.addEventListener("change",
        (e) => {
            const sendSmsOffers = (e.target as HTMLInputElement).checked;
            postDataText(window.config.sendSmsOffersChangedUrl, sendSmsOffers);
        });
}

function initSendCreditLimitOffersChanged() {
    const checkboxSelector = "[data-limit-offers]";
    $$(checkboxSelector).forEach(x => x.addDataBoundEventListener("change", (e) => {
        const sendCreditLimitOffers = (e.target as HTMLInputElement).checked;
        const callback = (resp: SendCreditLimitOffersResponse) => {
            const limitDetailsContainer = get("_Limit");
            const limitOverviewContainer = get("limit-overview-container");
            const freeLimit = get("free-limit");
            limitDetailsContainer.innerHTML = resp.limitDetails;
            $$(checkboxSelector).forEach(x => (x as HTMLInputElement).checked = sendCreditLimitOffers);
            freeLimit.innerHTML = resp.freeLimitText;
            limitOverviewContainer.innerHTML = resp.limitOverview;
            if (sendCreditLimitOffers) {
                show(limitOverviewContainer);
            }
            else {
                hide(limitOverviewContainer);
                initSendCreditLimitOffersChanged();
            }
        }
        postDataJson(window.config.sendCreditLimitOffersChangedUrl, sendCreditLimitOffers, callback);
    }))
}

function initRatingStars() {
    $$(".review-rating__stars").forEach(x => {
        const ratingStars = x as Element;
        const initialValue = ratingStars.querySelectorAll(".rating-star__filled").length;
        const stars = ratingStars.querySelectorAll("button");
        const buttonNextStars = get("button-next-stars");
        const starsCount = stars.length;
        const mouseOverEvents: VoidFunction[] = [];
        const mouseOutEvents: VoidFunction[] = [];
        for (let i = 0; i < starsCount; i++) {
            const rating = i + 1;
            const star = stars[i];
            const mouseOverEvent = () => fillRatingStars(stars, rating);
            mouseOverEvents.push(mouseOverEvent);
            star.addEventListener("mouseover", mouseOverEvent);
            const mouseOutEvent = () => fillRatingStars(stars, initialValue);
            star.addEventListener("mouseout", mouseOutEvent);
            mouseOutEvents.push(mouseOutEvent);
            star.addEventListener("click", mouseOverEvent);
            star.addEventListener("click", () => {
                for (let j = 0; j < starsCount; j++) {
                    stars[j].removeEventListener("mouseover", mouseOverEvents[j]);
                    stars[j].removeEventListener("mouseout", mouseOutEvents[j]);
                }
                buttonNextStars?.classList.remove("button--disabled");
                buttonNextStars?.setAttribute("data-rating", ""+rating)
            });
        }

    });
}

function openCommentPanel (resp: boolean) {
    if(resp){
        hide(get("product-review-panel-submitted-low-rating"));
        get("button-next-low-rating").classList.add("button--disabled");
        show(get("product-review-panel-comment"));
        get("button-next-comment").classList.remove("button--disabled");
    }
    toggle($(".alert__product-review"), !resp)
}

function initReviewPanel(){
    const commentForm = get("comment-form") as HTMLFormElement;
    const customerSupportForm = get("low-rating-contact-form") as HTMLFormElement;
    const buttonCancelSubmitLowRating = get("button-cancel-submit-low-rating");
    const buttonNextStars = get("button-next-stars");

    buttonCancelSubmitLowRating?.addEventListener("click", () => {
        hide(get("product-review-panel-submitted-low-rating"));
        get("button-next-low-rating").classList.add("button--disabled");
        show(get("product-review-panel-comment"));
        get("button-next-comment").classList.remove("button--disabled");
    });

    buttonNextStars?.addEventListener("click", () => {
        const panel = get("product-review-panel");
        const productId = panel.getAttribute("data-product-id");
        const productIdInt = parseInt(productId);
        hide(get("product-review-panel-rating"));
        const latestUnreviewedProductId = parseInt($(".my-review .open-product-review-panel")?.getAttribute("data-product-id"));
        const rating = parseInt(buttonNextStars.getAttribute("data-rating"));
        
        const callback = (resp: EuronicsResponse) => {
            if (!resp.html) return;

            get("my-review-container").innerHTML = resp.html;
            initProductReviewButtons();
        }
        const data: ReviewProductForm = { productId: productIdInt, rating: rating, isAnonymous: false, returnNextProduct: (productIdInt == latestUnreviewedProductId && latestUnreviewedProductId != null) };
        postDataJson(window.config.addProductReviewUrl, data, callback)
        
        if(parseInt(buttonNextStars.getAttribute("data-rating")) > 2){
            show(get("product-review-panel-comment"));
            get("button-next-comment").classList.remove("button--disabled");
        } else{
            show(get("product-review-panel-submitted-low-rating"));
            get("button-next-low-rating").classList.remove("button--disabled");
        }
        
    }, {once:true});

    commentForm?.addEventListener("submit", () => {
        const panel = get("product-review-panel");
        const productId = panel.getAttribute("data-product-id");
        const productIdInt = parseInt(productId);
        const reviewTextElm = get("ReviewText") as HTMLTextAreaElement
        const reviewText = reviewTextElm.value.trim()
        const formData = new FormData(commentForm)
        function nextPanel(force: boolean){
            if(force){
                hide(get("product-review-panel-comment"));
                show(get("product-review-panel-submitted-high-rating"));
                get("button-next-comment").classList.remove("button--disabled")   
            }
            toggle($(".alert__product-review"), !force)
        }

        if (!validateForm(commentForm)) return;
        
        if(reviewText){
            const isAnonymous = (get("IsAnonymous") as HTMLInputElement).checked
            const latestUnreviewedProductId = parseInt($(".my-review .open-product-review-panel")?.getAttribute("data-product-id"));
            formData.append("ProductId", productId)
            const data: ReviewProductForm = { productId: productIdInt, rating: 0, isAnonymous: isAnonymous, reviewText: reviewText, returnNextProduct: (productIdInt == latestUnreviewedProductId && latestUnreviewedProductId != null) }
            const callback = (resp: EuronicsResponse) => {
                if (resp.html){
                    get("my-review-container").innerHTML = resp.html;
                    nextPanel(true)
                    initProductReviewButtons();
                }else{
                    nextPanel(resp.data)
                }
            }
            
            postDataJson(window.config.addProductReviewUrl, data, callback)
        } else {
            nextPanel(true)
        }

        $$(".open-product-review-panel").forEach(x => {
            if(x.getAttribute("data-product-id") == productId){
                hide(x);
            }
        });
        $$(".review-button-reviewed").forEach(x => {
            if(x.getAttribute("data-product-id") == productId){
                show(x);
            }
        });
    })

    customerSupportForm?.addEventListener("submit", () => {
        if (!validateForm(customerSupportForm)) return;
        const formData = new FormData(customerSupportForm);
        postFormData(window.config.sendMessageToCustomerServiceProductReviewUrl, formData, openCommentPanel);
    });
}

function fillRatingStars(stars: NodeListOf<HTMLButtonElement>, filledCount: number) {
    const starsCount = stars.length;
    const emoteStar = get("emote-rating-star") as Element;
    if(!emoteStar) return // Hover star behaviour only works in panel
    const attr = emoteStar.getAttribute("data-emote-number");
    
    if(filledCount > 0){
        emoteStar.classList.remove("rating-star__unfilled");
        emoteStar.classList.remove("rating-star__emote-"+attr);
        emoteStar.classList.add("rating-star__emote-"+(filledCount-1));
        emoteStar.setAttribute("data-emote-number", (filledCount-1).toString())
    }else{
        emoteStar.classList.remove("rating-star__emote-"+attr);
        emoteStar.classList.add("rating-star__unfilled");
        emoteStar.setAttribute("data-emote-number", "");
    }
    
    for (let i = 0; i < starsCount; i++) {
        const subStar = stars[i].querySelector("i") as Element;
        const fillSubStar = i < filledCount;
        subStar.classList.toggle("rating-star__filled", fillSubStar);
        subStar.classList.toggle("rating-star__unfilled", !fillSubStar);
    }
}

function initHistorySearch() {
    get("historySearchText")?.addEventListener("input", filterHistoryRows);
    get("shoppingHistoryDateFrom")?.addEventListener("input", filterHistoryRows);
    get("shoppingHistoryDateTo")?.addEventListener("input", filterHistoryRows);
}

function filterHistoryRows() {
    const fromText = (get("shoppingHistoryDateFrom") as HTMLInputElement).value;
    const toText = (get("shoppingHistoryDateTo") as HTMLInputElement).value;
    const from = fromText ? new Date((get("shoppingHistoryDateFrom") as HTMLInputElement).value) : null;
    const to = toText ? new Date((get("shoppingHistoryDateTo") as HTMLInputElement).value) : null;
    setHistoryRowsVisibility(from, to);
}

function filterHistoryRowsClearDates() {
    (get("shoppingHistoryDateFrom") as HTMLInputElement).value = '';
    (get("shoppingHistoryDateTo") as HTMLInputElement).value = '';
    setHistoryRowsVisibility(null, null);
}

function setHistoryRowsVisibility(from: Date, to: Date) {
    const clearSearchContainer = get("clear-history-search-container");
    toggle(clearSearchContainer, from !== null || to !== null);
    clearSearchContainer.classList.toggle("d-flex", !isHidden(clearSearchContainer));
    const searchText = (get("historySearchText") as HTMLInputElement).value.toLowerCase();
    $$("[data-history-row]").forEach(x => {
        const elem = x as HTMLElement;
        const historyDate = new Date(elem.querySelector("[data-history-date]")?.getAttribute("data-history-date"));
        if (from && historyDate < from || to && historyDate > to) {
            hide(elem);
            return;
        }
        let matchesText = !searchText;
        if (searchText) {
            const searchables = elem.querySelectorAll("[data-history-search]");
            for (let i = 0; i < searchables.length; i++) {
                const searchable = searchables[i];
                if (searchable.innerHTML.toLowerCase().includes(searchText)) {
                    matchesText = true;
                    break;
                }
            }
        }
        toggle(elem, matchesText)
    });
}

function markAsRead(container: HTMLElement, id: string, type: number) {
    setReadStyle(container);
    const data = { id: id, type: type };
    postData(window.config.markAsReadUrl, data);
}


function setReadStyle(container: HTMLElement) {
    const unreadClass = "notification-unread";
    const readClass = "notification-read";
    if (container.classList.contains(unreadClass)) {
        const markAsReadButton = container.querySelector("[data-mark-as-read]");
        remove(markAsReadButton);
        container.classList.remove(unreadClass);
        container.classList.add(readClass);
        container.querySelectorAll(`.${unreadClass}`).forEach(x => {
            const elem = x as HTMLElement;
            elem.classList.remove(unreadClass);
            elem.classList.add(readClass);
        });
    }
}

function initMessages() {
    $$("[data-message-id]").forEach(x => {
        const elem = x as HTMLElement;
        const id = elem.getAttribute("data-message-id");
        const type = parseInt(elem.getAttribute("data-message-type"));
        elem.querySelector("[data-message-link]")?.addEventListener("click", () => {
            setReadStyle(elem);
        });
        elem.querySelector("[data-mark-as-read]")?.addEventListener("click", () => {
            markAsRead(elem, id, type);
        });
    });
}

function initAskForReceipt() {
    $$("[data-receipt-for]").forEach(x => {
        (x as Element).addEventListener("click", (e) => {
            const target = e.target as HTMLElement;
            const invoiceNo = target.getAttribute("data-receipt-for");
            const callback = (resp: string) => {
                target.parentElement.querySelector("[data-receipt-message]").innerHTML = resp;
                x.style.display = "none";
            }
            postDataText(window.config.askForReceiptUrl, invoiceNo, callback);
        });
    });
}

function initAdditionalWarrantyToCart() {
    $$("[data-aw-ref]").forEach(x => {
        (x as Element).addEventListener("click", (e) => {
            const elem = e.target as HTMLElement;
            const awRefId = parseInt(elem.getAttribute("data-aw-ref"));
            const isWebOrder = elem.getAttribute("data-is-web") === "True";
            const productListId = elem.getAttribute("data-product-list-id");
            const parentProductListId = elem.parentElement.getAttribute("data-product-list-id");
            const data = { 
                awRefId: awRefId,
                isWebOrder: isWebOrder,
                editCartFrom: productListId || parentProductListId
            };
            const callback = (resp: Response) => {
                return addedToCart(resp, elem);
            }
            postData(window.config.awToCartUrl, data, callback);
        });
    });
}

function downloadCert(elm: HTMLAnchorElement) {
    getData(elm.href, response => {
        const fileName = getFileNameFromResponse(response);
        const errorElement = elm.closest("[data-history-product]").querySelector("[data-warranty-document-error]");
        response.blob().then(blob => {
            if (blob.type === "text/html") {
                return blob.text().then(x => {
                    errorElement.innerHTML = x;
                });
            }
            else {
                errorElement.innerHTML = "";
                downloadFileFromBlob(blob, fileName);
                return null
            }
        })
    });
}

function requestCertificate(elm: HTMLAnchorElement) {
    const callback = (messageHtml: string) => {
        const messageContainer = get("message-container");
        messageContainer.innerHTML = messageHtml;
        window.scroll(0, 0);
    }    
    postDataText(elm.href, null, callback);
}

function initDownloadCertButtons() {
    $$("[data-download-cert]").forEach((x: HTMLAnchorElement) => {
        x.addDataBoundEventListener("click", (e: Event) => {
            e.preventDefault();
            downloadCert(x);
        });
    });
    
    $$("[data-request-cert]").forEach((anchor: HTMLAnchorElement) => {
        anchor.addDataBoundEventListener("click", (e: Event) => {
            e.preventDefault();
            requestCertificate(anchor);            
        });
    });
}

function changePasswordCallback(resp: Response) {
    return resp.text().then(x => { get("changePasswordForm").innerHTML = x; });
}

function contactInfoCallback(resp: Response) {
    return resp.text().then(x => {
        get("contactInfoForm").innerHTML = x;
    }).finally(() => {
            let errors = $$(".address__component .manual-address-container .field-validation-error");
            const errorField = $(".manual-address-errors");
            errors.forEach((error, _) => {
                errorField.textContent += " " + error.textContent
            });
        }
    );
}

export function initProductReviewButtons(){
    $$(".open-product-review-panel").forEach(x => {
        (x as Element).addEventListener("click", () => {
            const productId = parseInt(x.getAttribute("data-product-id"));
            const panelProductId = parseInt(get("product-review-panel")?.getAttribute("data-product-id"));
            const callback = (resp: string) => {
                if(resp != ""){
                    get("product-review-panel-container").innerHTML = resp;
                    initRatingStars();
                    initReviewPanel();
                    //1ms paus, et transition toimiks(Paneel tuleks sujuvalt nähtavale).
                    sleep(1).then(() => {
                        openPanel("product-review-panel");
                        checkContinueFromReview(x);
                    })
                }
            }
            if(productId != panelProductId){
                postDataText(window.config.getProductReviewPanelUrl, productId, callback);
            }else{
                openPanel("product-review-panel");
                checkContinueFromReview(x);
            }
        });
    });
}

function checkContinueFromReview(elem: HTMLElement){
    const continueFromReview = elem?.getAttribute("data-continue-from-review")?.toLowerCase() === "true";
    if(continueFromReview){
        hide(get("product-review-panel-rating"));
        show(get("product-review-panel-comment"));
        get("button-next-comment").classList.remove("button--disabled");
    }
}

function initProductReturn() {
    $$("[data-return]").forEach(x => x.addDataBoundEventListener("click", () => {
        const productId = parseInt(x.getAttribute("data-return"));
        const invoiceNo = x.closest("[data-history-row]").querySelector("[data-invoice]").innerHTML;
        const data = { invoiceNo: invoiceNo, productId: productId, type: CustomerSupportSubType.ReturnProduct, loadProducts: true };
        postDataText(window.config.productHelpFormUrl, data, fillPanelAndInitForm)
    })
    );
}

function initDownloadInvoice() {
    $$("[data-download-invoice]").forEach(x => {
        x.addDataBoundEventListener("click", (e: Event) => {
            const target = e.target as HTMLElement;
            const invoiceNo = target.getAttribute("data-download-invoice");
            const callback = (resp: Response) => {
                const fileName = getFileNameFromResponse(resp);
                return resp.blob().then(blob => {
                    if (blob.type === "text/html") {
                        return blob.text().then(y => {
                            (e.target as HTMLElement).parentElement.querySelector("[data-receipt-message]").innerHTML = y;
                            x.style.display = "none";
                        });
                    }
                    else {
                        downloadFileFromBlob(blob, fileName);
                        return null
                    }
                });
            }
            postData(window.config.downloadInvoiceUrl, invoiceNo, callback);
        });
    });
}

function initSaveParcel() {
    initStoreAndPostPackageSelections();
    get("save-parcel")?.addDataBoundEventListener("click", () => {
        if (get("ParcelLocationName").classList.contains("input-validation-error"))
            return;
      const selectedParcel = $("input[type=radio][name='PostPackagesModel.ParcelLocation.Id']:checked") as HTMLInputElement;
      const locationId = selectedParcel.value;
        const callback = (html: string) => {
            $(".shipping-message__container").innerHTML = html;
        }
        postDataText(window.config.saveParcelUrl, locationId, callback);
    });
}

function checkForProductCode(){
    const urlParams = new URLSearchParams(window.location.search);
    const productId = parseInt(urlParams.get('product'));
    const guid = urlParams.get('guid')
    const callback = (resp: string) => {
        if(resp != ""){
            get("product-review-panel-container").innerHTML = resp;
            initRatingStars();
            initReviewPanel();
            //1ms paus, et transition toimiks(Paneel tuleks sujuvalt nähtavale).
            sleep(1).then(() => {
                openPanel("product-review-panel");
            })
        }
    }
    if(productId && guid){
        postDataText(window.config.getProductReviewPanelUrl, productId, callback);
    }
}

function initTabButtons(){
    $$("[data-activate-tab]").forEach(x => {
        (x as Element).addEventListener("click", () => {
            const tabButton = x as HTMLElement;
            const tabId = tabButton.getAttribute("data-tab-id");
            const tab = get(tabId + "Link");
            if(tab){
                tab.scrollIntoView({ behavior: "smooth" });
                tab.click();
            }
        })
    })
}

window.addEventListener("load", () => {
    initOpenExpandableClick();
    initProductAccessoriesClick();
    initClearFilterClick();
    initOpenSavedLocationClick();
    initCarousels();
    initRemoveFromFavorites();
    initSendEmailOffersChanged();
    initSendSmsOffersChanged();
    initSendCreditLimitOffersChanged();
    initRatingStars();
    initReviewPanel();
    initMessages();
    initHistorySearch();
    initAskForReceipt();
    initAdditionalWarrantyToCart();
    initDownloadCertButtons();
    initComparisons();
    initForm("contactInfoForm", contactInfoCallback);
    initForm("changePasswordForm", changePasswordCallback);
    initDatePickers();
    initContactInfoFields();
    initProductReturn();
    initDownloadInvoice();
    initParcelTerminals();
    initSaveParcel();
    initProductReviewButtons();
    initForm("low-rating-contact-form", openCommentPanel);
    window.responsiveObserverFunctions = (window.responsiveObserverFunctions || [])
    window.responsiveObserverFunctions.push(centerActiveTab)
    checkForProductCode();
    initTabButtons();
});

window.addEventListener("resize", () => centerActiveTab());
